<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">List available Profiles</h3>
    <v-layout>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="#007CA4"
            dark
            @click="validate">
          Get Profile list >>
        </v-btn>
      </v-flex>
      <v-flex md10 style="background-color: white">
        <vue-json-pretty :path="'res'" :data=this.response> </vue-json-pretty>
      </v-flex>
    </v-layout>

  </v-form>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default  {
    components: {
      VueJsonPretty,
    },
    data: () => ({
      profiles: null,
      valid: true,
      response: "",
    }),
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      validate () {
        console.log("validate ref:", this.$refs)
        if (this.$refs.form.validate()) {
          this.listProfiles()
        }
      },
      listProfiles() {
        alisonJS.listProfiles().then((list) => {
          console.log(list)
              this.setColor('success')
              this.setSnack('Profiles obtained successfully')
              this.$emit('setProfiles',list.profiles);
            this.response = list;
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = e;
          })
      }
    },
  }
</script>
<style scoped lang='css'>
  .v-expansion-panel-header{
    background-color: #007CA4;
  }
</style>